<template>
    <section class="annto-download-file">
        <section class="header-wrap">
            <h4 class="title" @click="toAll">文件信息</h4>
            <el-button class="refresh" icon="el-icon-refresh" @click="refresh"></el-button>
        </section>
        <section class="content-wrap">
            <el-table :data="fileList" ref="dataTable" v-loadmore="loadMore" :height="200" v-loading="loading">
                <el-table-column
                    v-for="(item, index) in columns"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    :show-overflow-tooltip="true"
                >
                    <template v-slot="scope">
                        <div class="status" v-if="item.prop === 'fileStatus'">
                            <div :class="['point', scope.row.fileStatusPoint]"></div>
                            {{ scope.row.fileStatusText }}
                        </div>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="action" width="60" label="操作">
                    <template v-slot="scope">
                        <el-button v-if="isShowDownBtn(scope.row, scope.$index)" @click="downLoad(scope.row, scope.$index)" type="text" size="small">
                            下载
                        </el-button>
                    </template>
                </el-table-column>
                <!-- 加载更多提示 -->
                <template #append>
                    <div class="loadMoreText" v-html="paginationObj.loadMoreText"></div>
                </template>
            </el-table>
        </section>
    </section>
</template>

<script>
import useFilelist from './useFilelist';
export default {
    name: 'AnntDownloadFile',
    data() {
        return {};
    },
    mounted() {
    },
    directives: {
        /**
         * @description 监听element-ui表格滚动到底部
         */
        loadmore: {
            mounted(el, binding) {
                const selectWrap = el.querySelector('.el-table__body-wrapper');
                selectWrap.addEventListener('scroll', function () {
                    const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
                    binding.value(scrollDistance);
                });
            }
        }
    },
    setup(props, setupContext) {
        const { loading, fileList, columns, paginationObj, updateFileList, loadMoreList, getFileList } = useFilelist(props, setupContext);
        return {
            loading,
            fileList,
            columns,
            paginationObj,
            updateFileList,
            loadMoreList,
            getFileList
        };
    },
    methods: {
        loadMore(scrollDistance) {
            if (scrollDistance <= 0 && !this.paginationObj.loadMoreFinished && !this.paginationObj.loadMoreStatus) {
                this.loadMoreList('<em class="el-icon-loading"></em>加载中...');
                this.getFileList('more');
            }
        },
        isShowDownBtn(row) {
            return row.fileStatusText === '已生成';
        },
        downLoad(row) {
            window.open(row.downUrl, '_top');
        },
        refresh() {
            this.updateFileList(this.fileList, '<em class="el-icon-loading"></em>加载中...');
        },
        toAll() {
            const origin = window.location.origin;
            window.open(`${origin}/mdm.html#/oss-file`, '_new');
        }
    }
};
</script>
<style lang="less" scoped>
.annto-download-file {
    background: #fff;
    padding: 2px 0;
    .header-wrap {
        padding: 0 8px;
        padding-bottom: 8px;
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        .title {
            cursor: pointer;
            padding: 0;
            margin: 0;
        }
        .refresh {
            padding: 6px;
            i {
                font-size: 16px;
            }
        }
    }
    .content-wrap {
        padding: 8px 8px;
        border-left: 1px solid #eee;
        border-right: 1px solid #eee;
        .el-table td {
            height: 42px;
        }
        .status {
            line-height: 16px;
            .point {
                background: #eee;
                border-radius: 50%;
                width: 10px;
                height: 10px;
                display: inline-block;
                margin-right: 5px;
                &.green {
                    background: #00d082;
                }
                &.orange {
                    background: #ff8800;
                }
                &.blue {
                    background: #3a8ee6;
                }
                &.red {
                    background: #ed0000;
                }
            }
        }
        .loadMoreText {
            text-align: center;
            margin: 1rem 0;
        }
    }
}
</style>
